import React, { useState, useEffect } from 'react';
import { Container, Grid, useMediaQuery } from '@material-ui/core';
import './questionnaires-administration-edit-question.view.css';
import LabelPure from '../../pures/label/label.pure';
import {
  ButtonAddHLPure,
  ButtonHLPure,
  CheckBoxHLPure,
  DialogFormHLPure,
  DialogSystemGLPure,
  DropDownBtnHLPure,
  FilterHLPure,
  GridHLPure,
  InputFileHLPure,
  InputHLPure,
  InputIconPlusHLPure,
  SearchBarHLPure,
  SimpleLoading,
  TextAreaHLPure,
  CheckBoxTemplatePure,
  InputLogicHLPure
} from '../../pures';
import { NIL as NIL_UUID } from 'uuid';
import { LocalStorageService, QuestionnaireService } from '../../../services';
import { useTranslation } from 'react-i18next';
import { arrObjNoRepetElements } from '../../../utils';
import { debug } from 'request-promise';

const QuestionnairesAdministrationEditQuestionView = ({
  selectedQuestion,
  selectedQuestionnaire,
  user,
  token,
  showDetailComponent,
  toggleShowDetailComponent,
  hideShowDetails,
  variablesForQuestionnaire,
  variablesToShow,
  currencyUnits,
  toggleCompleteRequest,
  setStateNameComponentUser,
  setShowDetails,
  allInfoQuestionToSend,
  setAllInfoQuestionToSend,
  nameComponentUser,
  toggleErrorRequesting,
  toggleLoadingRequesting,
  toggleCompletedRequesting,
  showCompletedRequesting,
  showErrorRequesting,
  showLoadingRequesting,
  setAllInfoQuestionToSendStirng,
  setNameComponentUser,
  errorInfoQuestions,
  toggleCompletedQuestionsRequesting,
  questionnairesByUser,
  personTypes,
  getContractPersonTypes,
}) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(min-width:560px)")

  const [showGettingData, setShowGettingData] = useState(false);
  const [variableName, setVariableName] = useState(0);
  const [typeQuestion, setTypeQuestion] = useState('text');
  const [questionName, setQuestionName] = useState(selectedQuestion.question);
  const [helpText, setHelpText] = useState(selectedQuestion.helpText);
  const [showDialog, setShowDialog] = useState(false);
  const [nameDocumentSearch, setNameDocumentSearch] = useState('');
  const [typePersoneFilter, setTypePersoneFilter] = useState(Number(process.env.REACT_APP_PERSON_TYPE_CONTRACTOR_PHYSICAL_ID));
  const [documentsSelect, setDocumentSelect] = useState([]);
  const [allSelected, setAllSelected] = useState([]);
  const [dataDocsSelected, setDataDocsSelected] = useState([]);
  const [documentItem, setDocumentItem] = useState([]);
  const [showDialogAnswer, setShowDialogAnswer] = useState(false);
  const [answer, setAnswer] = useState('');
  const [dataAnswers, setDataAnswers] = useState([]);
  const [showDialogVariable, setShowDialogVariable] = useState(false);
  const [dataVariables, setDataVaribles] = useState([]);
  const [valueCheckBox, setValueCheckBox] = useState([]);
  let [allAnswers, setAllAnswers] = useState([]);
  const [variableDialogSelect, setVariableDialogSelect] = useState('');
  const [allVariablesSelect, setAllVaribleSelect] = useState([]);
  const [documentsForClient, setDocumentsForClient] = useState([]);
  const [variablesunshift, setVariablesUnshift] = useState([]);
  const [variablesToShowInDialog, setVariablesToShowInDialog] = useState([]);
  const [formatForVarible, setFormatForVariable] = useState(0);
  const [formatVariable, setFormatVariable] = useState(0);
  const [money, setMoney] = useState(0);
  const [moneyCheckBox, setMoneyCheckBox] = useState(false);
  const [unity, setUnity] = useState('');
  const [formatNumbers, setFormatNumbers] = useState([]);
  const [datesFormat, setDatesFormat] = useState([]);
  const [dateDrop, setDateDrop] = useState(0);
  const [showDialogAddDocumentRequest, setShowDialogAddDocumentRequest] =
    useState(false);
  const [requestDocument, setRequestDocument] = useState('');
  const [documentsWasCreatedSelect, setDocumentsWasCreatedSelect] = useState(
    []
  );
  const [checkBoxValueDocs, setCheckBoxDocs] = useState(false);
  const [allDocsCreateSelected, setAllDcosCreateSelected] = useState([]);
  const [documentsForClientCreated, setDocumentsForClientCreated] = useState(
    []
  );
  const [nameDocumentCreateSearch, setNameDocumentCreateSearch] = useState('');
  const [moneyAdd, setMoneyAdd] = useState('');
  const [simbolAdd, setSimbolAdd] = useState('');
  const [nameMoneyAdd, setNameMoneyAdd] = useState('');
  const [moneyCheckboxNoMoney, setMoneyCheckBoxNoMoney] = useState(false);
  const [moneyCheckBoxAddMoney, setMoneyCheckBoxAddMoney] = useState(false);
  const [unitAddMoneyLength, setUnitAddMoneyLength] = useState(0);
  const [variablesToFilter, setVariablesToFilter] = useState([]);
  const [variableAssigned, setVariableAssigned] = useState([]);
  const [nameVoidWarning, setNameVoidWarning] = useState(false);
  const [messageError, setMessageError] = useState('');
  const [showCurrency, setShowCurrency] = useState([])
  const [docsWasSave, setDocsWasSave] = useState([])
  const [optionsToShow, setOptionsToShow] = useState([])
  const [valueCheckBoxMoneyNoMoney, setValueCheckBoxMoneyNoMoney] = useState(false)
  const [valueCheckBoxMoney, setValueCheckBoxMoney] = useState(false)
  const [valueCheckBoxMoneyAddMoney, setValueCheckBoxMoneyAddMoney] = useState(false)
  const [showFormatForVariableOptions, setShowFormatForVariableOptions] = useState([])
  const [arrDatesBefore, setArrDatesBefero] = useState([])
  const [datesBefore, setDatesBefore] = useState(0)
  const [numbersBefore, setNumbersBefore] = useState(0)
  const [arrNumbersBefore, setArrNumbersefore] = useState([])
  const [varsFromBd, setVarsFomBd] = useState([])
  const [infoAnswerIdsFromBd, setInfoAnswerIdsFromBd] = useState([])
  const [docsCLientFromBD, setDocsCLientFromBD] = useState([])
  const [documentExist, setDocumentExist] = useState(false)
  const [dateValue, setDateValue] = useState(7)
  const [numbersValue, setNumbersValue] = useState(1)
  const [monedaTypeValue, setMonedaTypeValue] = useState(0)
  const [docsInBD, setDocsInBd] = useState([])
  const [varsInBd, setVarsInBd] = useState([])
  const [showDialogEditAnswer, setshowDialogEditAnswer] = useState(false)
  const [editAnswer, setEditAnswer] = useState('')
  const [editAnswerToSearch, setEditAnswerToSearch] = useState('')
  const [answersToSend, setAnswersToSend] = useState([])
  const [formatText, setFormatText] = useState([])
  const [textValue, setTextValue] = useState(0)
  const [textFormatSelected, setTextFormatSelected] = useState(13)
  const [typePersonsFilter, setTypePersonsFilter] = useState([])
  const [selectorOptions, setSelectorOptions] = useState(
    {
      type: [
        {
          name: t('questionnairesAdministrationEditQuestionView.selector.check.single'),
          value: true
        }, {
          name: t('questionnairesAdministrationEditQuestionView.selector.check.multiple'),
          value: false
        }
      ],
      options: [
        {
          name: '',
          value: false
        }
      ]
    }
  )
  const [logicOptions, setLogicOptions] = useState([
    {
      name: t('questionnairesAdministrationEditQuestionView.logic.labels.yes'),
      value: true
    },
    {
      name: t('questionnairesAdministrationEditQuestionView.logic.labels.no'),
      value: false
    }
  ])
  const [allFormatVars, setAllFormatVars] = useState([])

  let varsQuestionnaire = [
    {
      amountInLetters: null,
      currency: null,
      formatVariableId: '',
      id: 0,
      name: 'Sin variable',
      templateId: NIL_UUID,
      type: null,
      unit: null,
      updatedByUser: null,
    },
  ];

  const questionTypeOptions = [
    {
      name: t(
        'questionnairesAdministrationEditQuestionView.drop.type.question.value.text'
      ),
      value: 'text',
    },
    {
      name: 'Radio set',
      value: 'radio',
    },
    {
      name: 'Check box',
      value: 'check',
    },
  ];

  const formatForVariableOptions = [
    {
      id: 0,
      name: t('questionnairesAdministrationEditQuestionView.drop.format.labels.text'),
      value: 'text',
    },
    {
      id: 1,
      name: t('questionnairesAdministrationEditQuestionView.drop.format.labels.ammount'),
      value: 'amount',
    },
    {
      id: 2,
      name: t('questionnairesAdministrationEditQuestionView.drop.format.labels.date'),
      value: 'date',
    },
    {
      id: 3,
      name: t('questionnairesAdministrationEditQuestionView.drop.format.labels.logic'),
      value: 'logic'
    },
    {
      id: 4,
      name: t('questionnairesAdministrationEditQuestionView.drop.format.labels.selector'),
      value: 'selector'
    }
  ];

  const handleVariable = (e) => {
    let value = Number(e.target.value);
    setVariableName(value);
    if (value > 0) {
      let varAdd = variablesToShow.filter((variable) => variable.id === value);
      setVariableAssigned(varAdd[0]);
    }
  };

  const handleTypeQuestion = (e) => {
    setTypeQuestion(e.target.value);
  };
  const handleQuestionName = (e) => {
    setQuestionName(e.target.value);
  };

  const handleHelpText = (e) => {
    setHelpText(e.target.value);
  };

  const handleFormatToVariable = (e) => {
    setFormatForVariable(Number(e.target.value));
  };

  const handleFormatVariable = (e) => {
    setFormatVariable(Number(e.target.value));
  };

  const handleMoneyVariable = (e) => {
    //change No money to a money
    if (Number(money) === 0 && Number(e.target.value) > 0) {
      setMoneyCheckBox(moneyCheckboxNoMoney);
      setValueCheckBoxMoney(moneyCheckboxNoMoney);
    }

    //change money to no money
    if (Number(money) > 0 && Number(e.target.value) === 0) {
      setMoneyCheckBoxNoMoney(valueCheckBoxMoney);
      setValueCheckBoxMoneyNoMoney(valueCheckBoxMoney)
    }

    setMoney(e.target.value);
  };

  const handleUnidadInput = (e) => {
    setUnity(e.target.value);
  };

  const handleFormatDates = (e) => {
    setDateDrop(Number(e.target.value));
  };

  const handleInputAddDocument = (e) => {
    setDocumentExist(false)
    setRequestDocument(e.target.value);
  };

  const handleUnidadInputMoneyAdd = (e) => {
    setMoneyAdd(e.target.value);
  };

  const handleUnidadInputSimbolAdd = (e) => {
    setSimbolAdd(e.target.value);
  };

  const handleUnidadInputNameMoneyAdd = (e) => {
    setNameMoneyAdd(e.target.value);
  };

  const handleFormatText = (e) => {
    setTextFormatSelected(Number(e.target.value))
  }

  // show or hide dialog
  const toggleDialog = () => {
    setShowDialog(!showDialog);
  };

  // show or hide dialog Request
  const toggleDialogAnswer = () => {
    setShowDialogAnswer(!showDialogAnswer);
  };

  // show or hide dialog Request
  const toggleDialogVariable = () => {
    setShowDialogVariable(!showDialogVariable);
  };

  // show or hide dialog document add request
  const toggleDialogShowAddDocumentRequest = () => {
    setShowDialogAddDocumentRequest(!showDialogAddDocumentRequest);
  };

  // show or hide dialog Request
  const toggleDialogEditAnswer = () => {
    setshowDialogEditAnswer(!showDialogEditAnswer);
  };

  const handleCheckBoxMoney = (e) => {
    setMoneyCheckBox(e.target.checked);
    setValueCheckBoxMoney(e.target.checked);
  };

  //handle checkbox no money
  const handleCheckBoxMoneyNoMoney = (e) => {
    setMoneyCheckBoxNoMoney(e.target.checked);
    setValueCheckBoxMoneyNoMoney(e.target.checked)
  };

  //handle checkbos add money
  const handleCheckBoxAddMoney = (e) => {
    setMoneyCheckBoxAddMoney(e.target.checked);
    setValueCheckBoxMoneyAddMoney(e.target.checked)
  };

  //close dialog
  const cancelDialog = () => {
    toggleDialog();
  };

  //close answer dialog
  const cancelDialogAnswer = () => {
    toggleDialogAnswer();
  };

  //close variable dialog
  const cancelDialogVariabel = () => {
    toggleDialogVariable();
  };

  //close add document request
  const cancelDialogAddDocumentRequest = () => {
    toggleDialogShowAddDocumentRequest();
  };

  //close  edits answer dialog
  const cancelDialogEditAnswer = () => {
    setEditAnswerToSearch('')
    setEditAnswer('')
    toggleDialogEditAnswer();
  };

  //get Documents for client
  const getDocumentsClient = async () => {
    setShowGettingData(true);
    let questionnaireService = new QuestionnaireService(
      process.env.REACT_APP_MIFIRMA_API
    );
    let documentsClient = await questionnaireService.getDocumentsForClient(
      token
    );
    try {
      if (
        documentsClient &&
        Number(documentsClient.status) === 200 &&
        documentsClient.data &&
        documentsClient.data.data !== '' &&
        documentsClient.data.data !== null
      ) {
        documentsClient.data.data.map((documents) => {
          documents.typeDocument = t(
            'questionnairesAdministrationEditQuestionView-text-type-document-validation'
          );
          return documentsClient.data.data;
        });
        setDocumentsForClient(documentsClient.data.data);
        setDocumentSelect(documentsClient.data.data);
        setDocsWasSave(documentsClient.data.data)
      }
      setShowGettingData(false);
    } catch (error) {
      setShowGettingData(false);
      await toggleErrorRequesting(true);
      setTimeout(() => {
        toggleErrorRequesting(false);
      }, 2000);
      window.location.reload();
    }
  };

  //get documents was created by user
  const gteDocumentsWasCreated = () => {
    let docmentsWasCreated = [];
    setDocumentsWasCreatedSelect(docmentsWasCreated);
    setDocumentsForClientCreated(docmentsWasCreated);
  };

  //update question
  const updateQuestion = async () => {

    await toggleLoadingRequesting(true);
    if (
      questionName === '' ||
      questionName === undefined ||
      questionName === null
    ) {
      await toggleLoadingRequesting(false);
      setNameVoidWarning(true);
      setMessageError(
        t('questionnairesAdministrationEditQuestionView-void-name-question')
      );
      setTimeout(() => {
        setNameVoidWarning(false);
      }, 2000);
      return;
    }
    let questionnaireService = new QuestionnaireService(process.env.REACT_APP_MIFIRMA_API);
    let typeQuestionNoVariable = '';
    let optionToAnswer = '';
    let formatQuestionWithVariable = 'text';
    let detailFormatAmount = 13;
    let unitMoney = null;
    let unitForNoMoney = '';
    let checkBoxForNoMoney = false;
    let checkBoxForMoney = false;
    let moneyForAddMoney = '';
    let simbolForAddMoney = '';
    let nameMoneyForAddMoney = '';
    let checkBoxForAddMoney = false;
    let dateTypeForVariable = '';
    let docsValidate = [];
    let docsCreated = [];
    let variablesAdded = [];
    let requireClientDocument = false
    let allDocsSelect = []
    let docsSelectedToSend = []
    let answerSelected = false
    let answer = ''
    let fieldTypeId = 1
    let ammountInlettersCheckBox = false
    let answersArr = []
    let typeMoneda = {}
    //add clientId if create a money
    let clientId = user.userMetaData.userMifirma.clientId

    if (formatForVarible === 0) {
      detailFormatAmount = textFormatSelected
    }
    if (variableName === 0) {
      //get question type no variable
      let typeOfQuestion = questionTypeOptions.filter(
        (type) => type.value === typeQuestion
      );
      typeQuestionNoVariable =
        typeOfQuestion.length > 0 ? typeOfQuestion[0].value : 'text';
      answerSelected = typeQuestionNoVariable === 'text' ? true : false

      //get format for variable
      let formatForVariable = formatForVariableOptions.filter(
        (format) => format.id === formatForVarible
      );
      formatQuestionWithVariable = formatForVariable
        ? formatForVariable[0].value
        : 'text';

      if (typeQuestion === 'radio') {
        fieldTypeId = 2
      }

      if (typeQuestion === 'check') {
        fieldTypeId = 3

      }

      //get all ansewers if exist
      answersArr = dataAnswers.length > 0 ? dataAnswers : []

      //get option to answer no variable
      optionToAnswer = dataAnswers.length > 0 ? dataAnswers[0].name : '';
      answer = optionToAnswer
      variablesAdded = variableAssigned;
    } else {
      let formatForVariable = formatForVariableOptions.filter(
        (format) => format.id === formatForVarible
      );
      formatQuestionWithVariable = formatForVariable
        ? formatForVariable[0].value
        : 'text';

      answerSelected = formatQuestionWithVariable === 'text' ? true : false

      if (formatForVarible === 1 && variableName > 0) {
        //get detail format number for varibale and amount
        let numberFormat = formatVariable === 0 ? formatNumbers[0].id : formatVariable;
        let detailAmount = formatNumbers.filter(
          (format) => format.id === Number(numberFormat)
        );

        detailFormatAmount = detailAmount ? detailAmount[0].id : numberFormat;
        //get type money unity
        let currencySend = currencyUnits.filter(
          (currency) => currency.id === Number(money)
        );
        unitMoney = currencySend.length > 0 ? currencySend[0] : null;

        let moneyInfo = showCurrency.filter((moneda) => moneda.id === Number(money))
        typeMoneda = moneyInfo && moneyInfo[0] ? moneyInfo[0] : null
        if (moneyInfo[0].pluralName === t('questionnairesAdministrationEditQuestionView-option-no-money')) {
          //get unity for no money
          unitForNoMoney = unity;
          ammountInlettersCheckBox = moneyCheckboxNoMoney;
        } else if (moneyInfo[0].pluralName === t('questionnairesAdministrationEditQuestionView-option-add-money')) {
          //get unity for add money
          moneyForAddMoney = moneyAdd;
          //get simbol for add money
          simbolForAddMoney = simbolAdd;
          //get name money for add money
          nameMoneyForAddMoney = nameMoneyAdd;
          // get checkBox for add money
          ammountInlettersCheckBox = moneyCheckBoxAddMoney;
        } else {
          //get unity for money
          ammountInlettersCheckBox = moneyCheckBox;

        }
      }

      if (formatForVarible === 2 && variableName > 0) {
        let dateToSearch = dateDrop === 0 || dateDrop === '' ? datesFormat[0].id : dateDrop;
        let date = datesFormat.filter((date) => date.format === dateToSearch);
        detailFormatAmount = date && date.length > 0 ? date[0].id : dateToSearch;
      }

      //get documents related to question
      docsValidate = allSelected;
      docsCreated = allDocsCreateSelected;
      allDocsSelect = docsValidate.concat(docsCreated)
      requireClientDocument = allDocsSelect.length > 0 ? true : false
      //get all Variables
      variablesAdded = dataVariables;

      //add unity is not money
      if (formatForVarible === 1 && variableName > 0 && Number(money) === 0) {
        unitForNoMoney = unity
        ammountInlettersCheckBox = valueCheckBoxMoneyNoMoney
      }
    }

    let setOptions = false
    let selectorOptionsSave = null
    if (formatForVarible === 4 && variableName > 0) {
      selectorOptionsSave = { ...selectorOptions }
      selectorOptionsSave.options = selectorOptions.options.filter(option => option.name)
      let formatVarSelected = allFormatVars.find(format => format.key === process.env.REACT_APP_FORMAT_VARIABLES_KEY_SELECTOR)
      detailFormatAmount = (formatVarSelected) ? formatVarSelected.id : 13
      setOptions = (formatVarSelected) ? true : false
    }

    let setOptionsLogic = false
    let setOptionsLogicSave = null
    if (formatForVarible === 3 && variableName > 0) {
      setOptionsLogicSave = logicOptions.map((option) => {
        option.name = option.name || '---'
        return option
      })
      let formatVarSelected = allFormatVars.find(format => format.key === process.env.REACT_APP_FORMAT_VARIABLES_KEY_LOGIC)
      detailFormatAmount = (formatVarSelected) ? formatVarSelected.id : 13
      setOptionsLogic = (formatVarSelected) ? true : false
    }

    let requireTemplateVariableId = variableName > 0 ? true : false
    let infoQuestion = {
      variableId: variableName,
      typeRequest: typeQuestionNoVariable,
      questionName: questionName,
      helpText: helpText,
      formatVariable: formatQuestionWithVariable,
      detailFormatAmount: detailFormatAmount,
      unitMoney: unitMoney,
      unityNoMoney: unitForNoMoney,
      checkboxNoMoney: checkBoxForNoMoney,
      checkBoxMoney: checkBoxForMoney,
      addMoney: moneyForAddMoney,
      simbolAddMoney: simbolForAddMoney,
      nameAddMoney: nameMoneyForAddMoney,
      moneyCheckBoxAddMoney: checkBoxForAddMoney,
      formatDate: dateTypeForVariable,
      validationDocument: docsValidate,
      requestDocument: docsCreated,
      addVariables: variablesAdded,
      answersOptions: optionToAnswer,
      requireClientDocument: requireClientDocument,
      requireTemplateVariable: requireTemplateVariableId,
      clientId: clientId,
      answerSelected: answerSelected,
      answer: answer,
      fieldTypeId: fieldTypeId,
      type: formatQuestionWithVariable,
      formatForVaribleId: detailFormatAmount,
      currency: unitForNoMoney,
      amountInLetters: ammountInlettersCheckBox,
      answers: answersArr,
      selectorOptions: (setOptions) ? selectorOptionsSave : null,
      optionsLogic: (setOptionsLogic) ? setOptionsLogicSave : null
    };

    if (formatForVarible === 4 && variableName > 0 && selectorOptionsSave.options.length === 0) {
      setMessageError('Agrega una opción al selector.')
      await toggleLoadingRequesting(false)
      await toggleErrorRequesting(true)
      setTimeout(() => {
        toggleErrorRequesting(false)
      }, 4000);
      return
    }

    if (nameComponentUser === t('questionnairesAdministrationEditDetailView.btn.edit.question')) {
      let idimportan = infoQuestion && infoQuestion.variableId && infoQuestion.variableId > 0 ? infoQuestion.variableId : 0
      let questionSelected = allInfoQuestionToSend.filter((question) => question.id === selectedQuestion.id);
      let questionId = questionSelected[0].id
      let questionnaireId = questionSelected[0].questionnaireId
      let order = questionSelected[0].order
      let questionGroup = questionSelected[0].questionGroup
      let level = questionSelected[0].level
      let consecutive = questionSelected[0].consecutive
      let monetary = {}
      monetary.id = typeMoneda && typeMoneda.id > 0 ? typeMoneda.id : 0
      monetary.key = infoQuestion.nameAddMoney
      monetary.name = infoQuestion.nameAddMoney
      monetary.abbreviation = infoQuestion.addMoney
      monetary.symbol = infoQuestion.simbolAddMoney
      monetary.defaultMonetaryUnit = false
      monetary.creatorClientId = clientId
      monetary.action = infoQuestion.nameAddMoney && infoQuestion.nameAddMoney !== '' ? 1 : 0

      const monetaryUnitString = JSON.stringify(monetary)
      let answerArray = []
      if (variableName > 0) {
        if (infoQuestion.answers.length > 0) {
          for (let index = 0; index < infoQuestion.answers.length; index++) {
            let info = {}
            info.id = questionSelected[0].answers[index].answer.id
            info.templateVariableId = 0
            info.answerSelected = false
            info.answer = infoQuestion.answers[index].name
            answerArray.push(info)
          }
        } else {
          let varTemplateId = questionSelected && questionSelected[0] && questionSelected[0].answers.length > 0 ? questionSelected[0].answers[0].answer.id : 0
          let info = {
            id: varTemplateId,
            templateVariableId: idimportan,
            answerSelected: false,
            answer: ''
          }
          answerArray.push(info)
          for (let index = 0; index < infoQuestion.addVariables.length; index++) {
            let idAnswer = ''
            let varInfoInBd = infoAnswerIdsFromBd.filter((vari) => vari.idVar === infoQuestion.addVariables[index].id)
            if (varInfoInBd.length > 0) {
              idAnswer = varInfoInBd[0].idAnswer
            }
            let info = {}
            info.id = idAnswer
            info.templateVariableId = infoQuestion.addVariables[index].id
            info.answerSelected = false
            info.answer = ''
            answerArray.push(info)
          }
        }
      }

      let allVarsSend = []

      //verifica las variables que ya existen para actualizar o si se agregaron nuevas para crear
      let variables = questionSelected[0].answers
      if (variableName > 0 && variables.length > 0 && variables[0].answer) {
        variables[0].answer.templateVariableId = variableName
      }
      answerArray.map((answer) => {
        let variable = variables.find((variable) => variable.answer.templateVariableId === answer.templateVariableId)
        let info = {}
        info.id = answer.id
        info.templateVariableId = answer.templateVariableId
        info.answerSelected = false
        info.answer = ''
        if (variable) {
          info.action = 2
        } else {
          info.action = 1
        }
        allVarsSend.push(info)
        return answer
      })

      //verificar si se elimino una variable
      variables.map((variable) => {
        let varDeleted = answerArray.find((answer) => answer.templateVariableId === variable.answer.templateVariableId)
        let info = {}
        info.id = variable.answerId
        info.templateVariableId = variable.answer.templateVariableId
        info.answerSelected = false
        info.answer = ''
        if (!varDeleted) {
          info.action = 3
          allVarsSend.push(info)
        }
        return variable
      })

      let varsFilter = arrObjNoRepetElements(allVarsSend, 'id')
      const answerArrayString = JSON.stringify(varsFilter)

      let clientDocumentArr = []
      let documentsToSend = []
      //Nueva forma de enviar los documentos

      if (variableName > 0) {
        for (let i = 0; i < dataDocsSelected.length; i++) {
          dataDocsSelected[i].insert = false
          dataDocsSelected[i].questionClientDocumentId = ''
          let docWasSaveInBd = questionSelected[0].questionClientDocument.filter((doc) => doc.clientDocumentId === dataDocsSelected[i].id)
          if (docWasSaveInBd.length > 0) {
            dataDocsSelected[i].questionClientDocumentId = docWasSaveInBd[0].id
          }
          if (dataDocsSelected[i].id === '') {
            dataDocsSelected[i].insert = true
          }
          clientDocumentArr.push(dataDocsSelected[i])
        }
      }

      //comparar si han eliminado documentos de los que ya se habían guardado
      for (let index = 0; index < docsInBD.length; index++) {
        let existDoc = clientDocumentArr.filter((doc) => doc.id === docsInBD[index].id)
        if (existDoc && existDoc.length > 0) {
          docsInBD[index].action = 2
        } else {
          docsInBD[index].action = 3
        }
        let questionClientDocument = questionSelected[0].questionClientDocument.filter((doc) => doc.clientDocumentId === docsInBD[index].id)
        docsInBD[index].questionClientDocumentId = questionClientDocument && questionClientDocument.length > 0 ? questionClientDocument[0].id : ''
        documentsToSend.push(docsInBD[index])
      }

      //compara si se han añadido nuevo documentos de los que ya había
      for (let i = 0; i < clientDocumentArr.length; i++) {
        let existDoc = documentsToSend.filter((doc) => doc.id === clientDocumentArr[i].id)
        if (existDoc && existDoc.length === 0) {
          documentsToSend.push(clientDocumentArr[i])
        }
      }
      const clientDocumentString = JSON.stringify(documentsToSend)


      try {
        //update question with service
        let questionUpdated = await questionnaireService.updateQuestion(questionId, questionnaireId, infoQuestion.fieldTypeId, infoQuestion.questionName, infoQuestion.helpText, questionGroup, level, order, consecutive, infoQuestion.requireClientDocument, infoQuestion.requireTemplateVariable, infoQuestion.type, infoQuestion.formatForVaribleId, infoQuestion.currency, infoQuestion.amountInLetters, monetaryUnitString, answerArrayString, clientDocumentString, infoQuestion.selectorOptions, infoQuestion.optionsLogic, token)
        if (questionUpdated && Number(questionUpdated.statusCode) === 200) {
          await toggleLoadingRequesting(false);
          await toggleCompletedQuestionsRequesting(true)
          setNameComponentUser(t('questionnairesAdministrationView.btn.adm.questions.grid'));
          setTimeout(() => {
            setShowDetails(true);
            toggleCompletedQuestionsRequesting(false)
          }, 500);

        } else {
          await toggleLoadingRequesting(false)
          await toggleErrorRequesting(true)
          setTimeout(() => {
            toggleErrorRequesting(false)
          }, 2000);
        }
      } catch (error) {
        await toggleLoadingRequesting(false)
        await toggleErrorRequesting(true)
        setTimeout(() => {
          toggleErrorRequesting(false)
        }, 2000);
      }
    } else {
      let idimportan = infoQuestion && infoQuestion.variableId && infoQuestion.variableId > 0 ? infoQuestion.variableId : 0
      let copyQuestions = [...allInfoQuestionToSend]
      let questionPush = {}
      questionPush.question = {}
      questionPush.answer = {}
      questionPush.answer.monetaryUnit = {}
      questionPush.id = ''
      questionPush.questionId = ''
      questionPush.answerId = ''
      questionPush.notes = ''
      questionPush.question.id = ''
      questionPush.question.questionnaireId = selectedQuestionnaire.id
      questionPush.question.fieldTypeId = infoQuestion.fieldTypeId
      questionPush.question.fieldType = ''
      questionPush.question.order = allInfoQuestionToSend.length + 1
      questionPush.question.level = 1
      questionPush.question.questionGroup = infoQuestion.questionName + questionPush.question.order
      questionPush.question.question = infoQuestion.questionName
      questionPush.question.helpText = infoQuestion.helpText
      questionPush.question.type = infoQuestion.type
      questionPush.question.formatForVaribleId = infoQuestion.formatForVaribleId
      questionPush.question.currency = infoQuestion.currency
      questionPush.question.amountInLetters = infoQuestion.amountInLetters
      questionPush.question.requireClientDocument = infoQuestion.requireClientDocument
      questionPush.question.requireTemplateVariable = infoQuestion.templateVariableId
      questionPush.question.selectorOptions = infoQuestion.selectorOptions
      questionPush.answer.id = unitMoney ? unitMoney.id : null
      questionPush.answer.templateVariableId = idimportan
      questionPush.answer.answerSelected = infoQuestion.answerSelected
      questionPush.answer.answer = infoQuestion.answer
      questionPush.answer.monetaryUnit.id = typeMoneda && typeMoneda.id > 0 ? typeMoneda.id : 0
      questionPush.answer.monetaryUnit.key = infoQuestion.nameAddMoney
      questionPush.answer.monetaryUnit.name = infoQuestion.nameAddMoney
      questionPush.answer.monetaryUnit.abbreviation = infoQuestion.addMoney
      questionPush.answer.monetaryUnit.symbol = infoQuestion.simbolAddMoney
      questionPush.answer.monetaryUnit.defaultMonetaryUnit = false
      questionPush.answer.monetaryUnit.creatorClientId = clientId
      questionPush.answer.monetaryUnit.action = infoQuestion.nameAddMoney && infoQuestion.nameAddMoney !== '' ? 1 : 0

      let clientDocumentArr = []
      for (let i = 0; i < dataDocsSelected.length; i++) {
        dataDocsSelected[i].insert = false
        if (dataDocsSelected[i].id === '') {
          dataDocsSelected[i].insert = true
        }
        clientDocumentArr.push(dataDocsSelected[i])
      }

      let templateVariableArray = []
      for (let index = 0; index < infoQuestion.addVariables.length; index++) {
        templateVariableArray.push(infoQuestion.addVariables[index].id)
      }

      let answerArray = []
      for (let index = 0; index < infoQuestion.answers.length; index++) {
        answerArray.push(infoQuestion.answers[index].name)
      }
      let order = 0
      let questionGroup = ''
      let level = 1
      if (allInfoQuestionToSend.length > 0) {
        let lastQuestion = allInfoQuestionToSend.pop()
        let split = lastQuestion.consecutive.split('.')
        order = Number(split[0]) + 1
        questionGroup = infoQuestion.questionName + order
      } else {
        order = 1
        questionGroup = infoQuestion.questionName + order
      }
      let consecutive = order + '.0.0'
      const variablesString = JSON.stringify(templateVariableArray)
      const clientDocumentString = JSON.stringify(clientDocumentArr)
      const answerArrayString = JSON.stringify(answerArray)
      const monetaryUnitString = JSON.stringify(questionPush.answer.monetaryUnit)

      try {
        let questionCreated = await questionnaireService.createQuestion(selectedQuestionnaire.id, infoQuestion.fieldTypeId, infoQuestion.questionName, infoQuestion.helpText, questionGroup, level, order, consecutive, infoQuestion.requireClientDocument, infoQuestion.requireTemplateVariable, idimportan, infoQuestion.answerSelected, answerArrayString, variablesString, infoQuestion.type, infoQuestion.formatForVaribleId, infoQuestion.currency, infoQuestion.amountInLetters, monetaryUnitString, clientDocumentString, infoQuestion.selectorOptions, infoQuestion.optionsLogic, token)
        if (questionCreated && Number(questionCreated.statusCode) === 200) {
          await toggleLoadingRequesting(false);
          await toggleCompletedQuestionsRequesting(true)
          setNameComponentUser(t('questionnairesAdministrationView.btn.adm.questions.grid'));
          setTimeout(() => {
            setShowDetails(true);
            toggleCompletedQuestionsRequesting(false)
          }, 500);

        } else {
          await toggleLoadingRequesting(false)
          await toggleErrorRequesting(true)
          setTimeout(() => {
            toggleErrorRequesting(false)
          }, 2000);
        }
      } catch (error) {
        await toggleLoadingRequesting(false)
        await toggleErrorRequesting(true)
        setTimeout(() => {
          toggleErrorRequesting(false)
        }, 2000);
      }
    }

  };

  //get all formats for variables
  const getFormatsForVariables = async () => {
    let questionnaireService = new QuestionnaireService(
      process.env.REACT_APP_MIFIRMA_API
    );
    try {
      let formatsVariables =
        await questionnaireService.getAllFormatsForVariables(token);
      let numbersFormat = formatsVariables.filter(
        (format) => format.groupName === 'number'
      );
      let formatdates = formatsVariables.filter(
        (format) => format.groupName === 'date'
      );
      let formatsText = formatsVariables.filter(
        (format) => format.groupName === 'text'
      );

      setAllFormatVars(formatsVariables)
      setFormatNumbers(numbersFormat);
      setDatesFormat(formatdates);
      setFormatText(formatsText)
    } catch (error) {
      setShowGettingData(false);
      await toggleErrorRequesting(true);
      setTimeout(() => {
        toggleErrorRequesting(false);
      }, 2000);
      window.location.reload();
    }
  };

  useEffect(() => {
    getDocumentsClient();
    getFormatsForVariables();
    getContractPersonTypes();
    let copyVariables = [...variablesToShow];
    let copyVariablesToFilter = [...variablesToShow];
    copyVariables.unshift(varsQuestionnaire[0]);
    setShowFormatForVariableOptions(formatForVariableOptions)
    if (nameComponentUser === t('questionnairesAdministrationEditDetailView.btn.edit.question')) {
      //config if question has variable asigned and unshift in array to show variables
      let questionSelected = allInfoQuestionToSend.filter((variable) => variable.id === selectedQuestion.id);
      if (questionSelected.length > 0 && questionSelected[0].answers.length > 0 && questionSelected[0].answers[0].answer.templateVariableId > 0) {
        let varAdd = variablesForQuestionnaire.filter(
          (variable) => variable.id === questionSelected[0].answers[0].answer.templateVariableId
        );
        setVariableName(varAdd[0].id);
        copyVariables.unshift(varAdd[0]);
        copyVariablesToFilter.unshift(varAdd[0]);

        //set unitys
        setUnity(questionSelected[0].currency)
        //set checkbox unity
        setValueCheckBoxMoneyNoMoney(questionSelected[0].amountInLetters)
        setMoneyCheckBoxNoMoney(questionSelected[0].amountInLetters)
        setMoneyCheckBox(questionSelected[0].amountInLetters)
        setMoneyCheckBoxAddMoney(questionSelected[0].amountInLetters)
        setValueCheckBoxMoneyAddMoney(questionSelected[0].amountInLetters)
        setValueCheckBoxMoney(questionSelected[0].amountInLetters)

        //Format for variable
        if (questionSelected[0].formatVariable.groupName === 'number') {
          let options = formatForVariableOptions.filter((option) => option.value === 'amount')
          let optionsNew = formatForVariableOptions.filter((option) => option.value !== 'amount')
          optionsNew.unshift(options[0])

          if (questionSelected[0] && questionSelected[0].monetaryUnit && questionSelected[0].monetaryUnit.id > 0) {
            setMonedaTypeValue(questionSelected[0].monetaryUnit.id)
            setMoney(questionSelected[0].monetaryUnit.id)
          }
          setArrNumbersefore(optionsNew)
          setNumbersBefore(Number(1))

          //set unity Money

        } else if (questionSelected[0].formatVariable.groupName === 'date') {
          //set date
          let options = formatForVariableOptions.filter((option) => option.value === 'date')
          let optionsNew = formatForVariableOptions.filter((option) => option.value !== 'date')
          optionsNew.unshift(options[0])
          setArrDatesBefero(optionsNew)
          setDatesBefore(Number(2))

          //set unit date
          let copyDates = [...datesFormat]
          let date = copyDates.filter((date) => date.id === questionSelected[0].formatVariable.id)
          let newDates = copyDates.filter((date) => date.id === questionSelected[0].formatVariable.id)
          newDates.unshift(date[0])
          setDateDrop(questionSelected[0].formatVariable.id)
        } else if (questionSelected[0].formatVariable.groupName === 'selection') {
          let options = formatForVariableOptions.find((option) => option.value === 'selector')
          let optionsNew = formatForVariableOptions.filter((option) => option.value !== 'selector')
          optionsNew.unshift(options)
          setArrDatesBefero(optionsNew)
          setDatesBefore(Number(4))
        } else if (questionSelected[0].formatVariable.groupName === 'logic') {
          let options = formatForVariableOptions.find((option) => option.value === 'logic')
          let optionsNew = formatForVariableOptions.filter((option) => option.value !== 'logic')
          optionsNew.unshift(options)
          setArrDatesBefero(optionsNew)
          setDatesBefore(Number(3))
        } else {
          setTextValue(questionSelected[0].formatVariable.id)
          setTextFormatSelected(questionSelected[0].formatVariable.id)
          setShowFormatForVariableOptions(formatForVariableOptions)
        }

        //set variables add
        let AllVariables = []
        let AllVariablesAdded = []
        let idAnswerBd = []
        let variables = questionSelected[0].answers
        for (let index = 0; index < variables.length; index++) {
          let idVar = variables[index].answer.templateVariableId
          if (index > 0 && idVar > 0) {
            let infoIds = {}
            infoIds.idAnswer = variables[index].answer.id
            infoIds.idVar = idVar
            idAnswerBd.push(infoIds)
            AllVariables.push(idVar)
          }
        }

        for (let i = 0; i < AllVariables.length; i++) {
          let info = {}
          let variable = variablesForQuestionnaire.filter((variable) => variable.id === AllVariables[i])
          AllVariablesAdded.push(variable[0])
        }
        setInfoAnswerIdsFromBd(idAnswerBd)
        setDataVaribles(AllVariablesAdded)
        setVarsInBd(AllVariablesAdded)
        setVarsFomBd(AllVariablesAdded)

        //set require documents
        let documents = questionSelected[0].questionClientDocument
        let allDocs = []
        for (let l = 0; l < documents.length; l++) {
          documents[l].clientDocument.typeDocument = t('questionnairesAdministrationEditQuestionView-text-type-document-validation')
          allDocs.push(documents[l].clientDocument)
        }
        setDataDocsSelected(allDocs)
        setDocsCLientFromBD(allDocs)
        setDocsInBd(allDocs)

        //set monetary if exist
        if (questionSelected[0] && questionSelected[0].monetaryUnit) {
          setMoneyAdd(questionSelected[0].monetaryUnit.abbreviation)
          setSimbolAdd(questionSelected[0].monetaryUnit.symbol)
          setNameMoneyAdd(questionSelected[0].monetaryUnit.name)
          setMoney(questionSelected[0].monetaryUnit.id)

        }
      } else {
        //set answers
        let allAsnwers = []
        let asnwers = questionSelected[0].answers
        for (let index = 0; index < asnwers.length; index++) {
          if (asnwers[index].answer.answer !== '' && asnwers[index].answer.answer !== undefined && asnwers[index].answer.answer !== null) {
            let info = {}
            info.name = asnwers[index].answer.answer
            info.id = asnwers[index].answer.id
            info.templateVariableId = 0
            info.answerSelected = false
            info.answer = asnwers[index].answer.answer
            info.action = 2
            allAsnwers.push(info)
          }
        }

        setDataAnswers(allAsnwers)
        setAllAnswers(allAsnwers)
        setAnswersToSend(allAsnwers)

        if (questionSelected[0].fieldType.id === 1) {
          setTextValue(questionSelected[0].formatVariable.id)
          setTextFormatSelected(questionSelected[0].formatVariable.id)
        }

      }
      setVariablesToFilter(copyVariablesToFilter);
      setVariablesUnshift(copyVariables);

    } else {
      setVariablesToFilter(copyVariablesToFilter);
      setVariablesUnshift(copyVariables);
      setVariableName(0)
      setFormatForVariable(0)
      setTypeQuestion('text')
      setFormatVariable(0)
      setMoney(0)
      setUnity('')
      setMoneyCheckBoxNoMoney(false);
      setMoneyAdd('')
      setSimbolAdd('')
      setNameMoneyAdd('')
      setMoneyCheckBoxAddMoney(false)
      setDateDrop('')
      setQuestionName('')
      setHelpText('')
      setDataAnswers([])
      setAllAnswers([])
      setDataDocsSelected([])
      setDataVaribles([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);



  useEffect(() => {
    let documentsCopy = [...docsWasSave];
    if (nameComponentUser === t('questionnairesAdministrationEditDetailView.btn.edit.question')) {
      let questionSelected = allInfoQuestionToSend.filter((variable) => variable.id === selectedQuestion.id);
      if (questionSelected.length > 0 && questionSelected[0].answers.length > 0 && questionSelected[0].answers[0].answer.templateVariableId > 0) {
        if (questionSelected[0].formatVariable.groupName === 'number') {
          //Format for variable
          setFormatForVariable(numbersBefore)
          setShowFormatForVariableOptions(arrNumbersBefore)
          //set detail format
          setNumbersValue(questionSelected[0].formatVariable.id)

        } else if (questionSelected[0].formatVariable.groupName === 'date') {
          // set Format for variable
          setFormatForVariable(datesBefore)
          setShowFormatForVariableOptions(arrDatesBefore)

          //set unit date
          setDateDrop(questionSelected[0].formatVariable.id)
          setDateValue(questionSelected[0].formatVariable.id)
        } else if (questionSelected[0].formatVariable.groupName === 'selection') {
          // set Format for variable
          setFormatForVariable(datesBefore)
          setShowFormatForVariableOptions(arrDatesBefore)
          setFormatForVariable(4)

          //set unit date
          let selectorOptions = (questionSelected && questionSelected[0] && questionSelected[0].selectorOptions) ? questionSelected[0].selectorOptions : { type: [{ name: 'Selección única', value: true }, { name: 'Selección múltiple', value: false }], options: [{ name: '' }] }
          setSelectorOptions(selectorOptions)
        } else if (questionSelected[0].formatVariable.groupName === 'logic') {
          // set Format for variable
          setFormatForVariable(datesBefore)
          setShowFormatForVariableOptions(arrDatesBefore)
          setFormatForVariable(3)

          //set unit date
          let optionslogic = (questionSelected && questionSelected[0] && questionSelected[0].optionsLogic) ? questionSelected[0].optionsLogic : [{ name: '' }]
          setLogicOptions(optionslogic)
        }
      }

      //config if question has variable asigned and unshift in array to show variables
      let varSearch = allInfoQuestionToSend.filter(
        (variable) => variable.id === selectedQuestion.id
      );

      let dataUpadate = []
      if (varSearch.length > 0 && varSearch[0].answers > 0 && varSearch[0].answers[0].answer && varSearch[0].answers[0].answer.templateVariableId > 0 && documentsCopy && documentsCopy.length > 0) {
        for (let index = 0; index < varSearch[0].question.questionClientDocument.length; index++) {
          let docsArr = documentsCopy.filter((doc) => doc.id === varSearch[0].question.questionClientDocument[index].clientDocumentId);
          dataUpadate.push(docsArr[0])
        }
        setDataDocsSelected(dataUpadate);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [docsWasSave])


  useEffect(() => {
    setOptionsToShow(questionTypeOptions)
    if (nameComponentUser === t('questionnairesAdministrationEditDetailView.btn.edit.question')) {
      let tipeField = ''
      let optionsConfig = {}
      if (allInfoQuestionToSend && allInfoQuestionToSend.length > 0) {
        let questionSelect = allInfoQuestionToSend.filter((question) => question.id === selectedQuestion.id)
        if (questionSelect.length > 0 && questionSelect[0].answers.length > 0 && questionSelect[0].answers[0].answer.templateVariableId === 0) {
          if (questionSelect[0].fieldType.id === 2) {
            optionsConfig = questionTypeOptions.filter((option) => option.value === 'radio')
            let newOpions = questionTypeOptions.filter((option) => option.value !== 'radio')
            newOpions.unshift(optionsConfig[0])
            setTypeQuestion('radio')
            setOptionsToShow(newOpions)
          }

          if (questionSelect[0].fieldType.id === 3) {
            optionsConfig = questionTypeOptions.filter((option) => option.value === 'check')
            let newOpions = questionTypeOptions.filter((option) => option.value !== 'check')
            newOpions.unshift(optionsConfig[0])
            setTypeQuestion('check')
            setOptionsToShow(newOpions)
          }

          if (questionSelect[0].fieldType.id !== 1) {
            for (let k = 0; k < questionSelect[0].answers.length; k++) {
              let asnwerObj = {};
              if (questionSelect[0].answers[k].templateVariableId === 0) {
                asnwerObj.name = questionSelect[0].answers[k].answer;
                asnwerObj.id = questionSelect[0].answers[k].id
                asnwerObj.templateVariableId = 0
                asnwerObj.answerSelected = false
                asnwerObj.answer = questionSelect[0].answers[k].answer
                asnwerObj.action = 2
                allAnswers.push(asnwerObj);

                setDataAnswers(allAnswers);
                setAllAnswers(allAnswers)
                setAnswersToSend(allAnswers)
              }
            }
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedQuestion])

  //search by search input
  const searchChangeDialog = (e) => {
    setNameDocumentSearch(e.target.value);
  };

  //changes data dropdown to show by search
  useEffect(() => {
    let documentsCopy = [...documentsForClient];
    if (nameDocumentSearch !== '') {
      let dataUpadate = documentsCopy.filter((doc) => {
        return (
          doc.name.indexOf(nameDocumentSearch) >= 0 &&
          doc.documentPersonTypeId === Number(typePersoneFilter)
        );
      });

      var docsNoSelect = allSelected.filter(
        (doc) => !dataUpadate.includes(doc)
      );
      for (let i = 0; i < docsNoSelect.length; i++) {
        docsNoSelect[i].check = true;
        dataUpadate.unshift(docsNoSelect[i]);
      }
      setDocumentSelect(dataUpadate);
    } else {
      let dataUpadate = documentsCopy.filter((doc) => {
        return doc.documentPersonTypeId === Number(typePersoneFilter);
      });
      let allDocs = allSelected.concat(dataUpadate);
      setDocumentSelect(allDocs);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nameDocumentSearch]);

  //changes data dropdown to show by filter
  useEffect(() => {
    if (Number(typePersoneFilter) > 0) {
      let documentsCopy = [...documentsForClient];
      let dataUpadate = documentsCopy.filter((doc) => {
        return doc.documentPersonTypeId === Number(typePersoneFilter);
      });

      const docsRemove = dataUpadate.filter((doc) => doc.check === true);
      for (let index = 0; index < docsRemove.length; index++) {
        const indexRemove = dataUpadate.findIndex(
          (doc) => doc.id === docsRemove[index].id
        );
        let questionRemoved = dataUpadate.splice(indexRemove, 1);
      }

      for (let i = 0; i < allSelected.length; i++) {
        let docWasSelected = dataUpadate.filter(
          (doc) => doc.id === allSelected[i].id
        );
        if (docWasSelected.length === 0) {
          allSelected[i].check = true;
          dataUpadate.unshift(allSelected[i]);
        }
      }
      setDocumentSelect(dataUpadate);
    } else {
      const docsRemove = documentsForClient.filter((doc) => doc.check === true);
      for (let index = 0; index < docsRemove.length; index++) {
        const indexRemove = documentsForClient.findIndex(
          (doc) => doc.id === docsRemove[index].id
        );
        let questionRemoved = documentsForClient.splice(indexRemove, 1);
      }

      for (let i = 0; i < allSelected.length; i++) {
        let docWasSelected = allSelected.filter(
          (doc) => doc.id === allSelected[i].id
        );
        if (docWasSelected.length <= 1) {
          allSelected[i].check = true;
          documentsForClient.unshift(allSelected[i]);
        }
      }
      setDocumentSelect(documentsForClient);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [typePersoneFilter]);

  useEffect(() => {
    if (!personTypes || personTypes.length === 0) return

    setTypePersonsFilter(personTypes)
  }, [personTypes])

  //handle checkbox
  const handleChangeCheckbox = (event) => {
    setValueCheckBox(event.target.checked);
    let copyDocs = [...allSelected]
    if (event.target.checked === true) {
      let doc = documentsForClient.find((doc) => doc.name === event.target.name);
      doc.check = event.target.checked;
      copyDocs.push(doc);
      setAllSelected(copyDocs);
    } else {
      let doc = documentsForClient.find((doc) => doc.name === event.target.name);
      doc.check = event.target.checked;
      let newDocs = copyDocs.filter((doc) => doc.name !== event.target.name);
      setAllSelected(newDocs);
    }
  };

  //handle documents was selected on dialog
  const handleSelectDialogDocuments = (e) => {
    let docsSelected = [];
    let copyDocs = [...docsCLientFromBD]
    if (allSelected.length > 0) {
      for (let i = 0; i < allSelected.length; i++) {
        let documentsCopy = [...documentsForClient];
        let dataUpadate = documentsCopy.filter((doc) => {
          return doc.name.indexOf(allSelected[i].name) >= 0;
        });
        dataUpadate[0].action = 2
        let docExistInBd = copyDocs.filter((doc) => doc.id === allSelected[i].id)
        if (docExistInBd && docExistInBd.length === 0) {
          docsSelected.push(dataUpadate[0]);
        }
      }
      let allDocsSelect = allDocsCreateSelected.concat(docsSelected);
      for (let index = 0; index < allDocsSelect.length; index++) {
        copyDocs.push(allDocsSelect[index])

      }
      setDataDocsSelected(copyDocs);
      setDocumentSelect(allSelected);
    } else {
      let allDocsSelect = allDocsCreateSelected.concat(docsSelected);
      for (let index = 0; index < allDocsSelect.length; index++) {
        copyDocs.push(allDocsSelect[index])
      }
      setDataDocsSelected(copyDocs);
      setDocumentSelect(documentsForClient);
    }

    toggleDialog();
  };

  const addOption = () => {
    let arrayCopy = { ...selectorOptions }
    arrayCopy.options.push({ name: '', value: false })
    setSelectorOptions(arrayCopy)
  }

  const handleChangeCheckboxSelector = (e, name) => {
    let copySelector = { ...selectorOptions }
    copySelector.type = copySelector.type.map((type) => {
      type.value = (type.name === name) ? true : false
      return type
    })
    setSelectorOptions(copySelector)
  }


  const onChangeTextSelection = (e, index) => {
    let copySelector = { ...selectorOptions }
    let findOption = copySelector.options.find((_, indexItem) => indexItem === index)
    findOption.name = e.target.value
    setSelectorOptions(copySelector)
  }

  const onChangeTextlogic = (e, index) => {
    let copySelector = [...logicOptions]
    let findOption = copySelector.find((_, indexItem) => indexItem === index)
    findOption.name = e.target.value
    setLogicOptions(copySelector)
  }

  //set options to choose documents when open dialog
  useEffect(() => {
    let documentsCopy = [...documentsForClient];
    //first filter by persona fisica
    let dataUpadate = documentsCopy.filter((doc) => {
      return doc.documentPersonTypeId === Number(process.env.REACT_APP_PERSON_TYPE_CONTRACTOR_PHYSICAL_ID);
    });
    setDocumentSelect(dataUpadate);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showDialog]);

  //search by search input in document create dialog
  const searchChangeDialogDocCreated = (e) => {
    setNameDocumentCreateSearch(e.target.value);
  };

  //changes data dropdown to show by search in create document dialog
  useEffect(() => {
    if (nameDocumentCreateSearch !== '') {
      let documentsCopy = [...documentsForClientCreated];
      let dataUpadate = documentsCopy.filter((doc) => {
        return doc.name.indexOf(nameDocumentCreateSearch) >= 0;
      });

      var docsNoSelect = allDocsCreateSelected.filter(
        (doc) => !dataUpadate.includes(doc)
      );

      for (let i = 0; i < docsNoSelect.length; i++) {
        docsNoSelect[i].check = true;
        dataUpadate.unshift(docsNoSelect[i]);
      }
      setDocumentsWasCreatedSelect(dataUpadate);
    } else {
      let docsNoSelect = documentsForClientCreated.filter(
        (doc) => !allDocsCreateSelected.includes(doc)
      );
      let allDocs = allDocsCreateSelected.concat(docsNoSelect);
      setDocumentsWasCreatedSelect(allDocs);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nameDocumentCreateSearch]);

  //save a new document request and add tu all documents
  const saveDocumentRequest = async () => {
    if (requestDocument === '') {
      return;
    }

    let clientId = user.userMetaData.userMifirma.clientId;
    let existDocument = false
    try {
      //verify if exist a document in bd with same name
      let questionnaireService = new QuestionnaireService(process.env.REACT_APP_MIFIRMA_API);
      let existDocumentVerify = await questionnaireService.verifyIfExistDocumentWithSameName(requestDocument, clientId, token)
      if (existDocumentVerify && Number(existDocumentVerify.status) === 200 && existDocumentVerify.data && existDocumentVerify.data.data === true) {
        existDocument = true
      }
    } catch (error) {
      existDocument = false
    }

    if (existDocument) {
      setDocumentExist(true)
      return
    }

    let documentsCopy = [...documentsForClientCreated];
    let documentToAdd = {
      action: 1,
      check: true,
      clientDocumentAction: {},
      clientDocumentActionId: 2,
      clientId: clientId,
      clientDocumentTypeRequestId: 0,
      createdDate: '',
      defaultDocument: false,
      description: '',
      documentPersonType: {},
      documentPersonTypeId: Number(process.env.REACT_APP_PERSON_TYPE_CONTRACTOR_PHYSICAL_ID),
      id: '',
      insert: true,
      name: requestDocument,
      order: null,
      typeDocument: t('questionnairesAdministrationEditQuestionView-text-type-document-request'),
      updatedByUser: '',
      updatedDate: '',
    };


    documentsCopy.push(documentToAdd);
    setDocumentsForClientCreated(documentsCopy);
    setDocumentsWasCreatedSelect(documentsCopy);
    setAllDcosCreateSelected(documentsCopy);
  };

  //handle check box dialog documents was created
  const handleCheckBoxDocumentsWasCreated = (e) => {
    setCheckBoxDocs(e.target.checked);
    let copyDocsSelected = [...allDocsCreateSelected];
    if (e.target.checked === true) {
      let doc = documentsForClientCreated.filter(
        (doc) => doc.name === e.target.name
      );
      doc[0].check = e.target.checked;
      copyDocsSelected.push(doc[0]);
      setAllDcosCreateSelected(copyDocsSelected);
    } else {
      let doc = documentsForClientCreated.filter(
        (doc) => doc.name === e.target.name
      );
      doc[0].check = e.target.checked;
      let newDocs = copyDocsSelected.filter(
        (doc) => doc.name !== e.target.name
      );
      setAllDcosCreateSelected(newDocs);
    }
  };

  //handle btn accept for dialog create document
  const handleDocCreated = () => {
    let docsSelected = [];
    let copyDocs = [...docsCLientFromBD]
    if (allDocsCreateSelected.length > 0) {
      for (let i = 0; i < allDocsCreateSelected.length; i++) {
        let documentsCopy = [...documentsForClientCreated];
        let dataUpadate = documentsCopy.filter((doc) => {
          return doc.name.indexOf(allDocsCreateSelected[i].name) >= 0;
        });
        docsSelected.push(dataUpadate[0]);
      }
      let allDocsSelect = allSelected.concat(docsSelected);
      for (let index = 0; index < allDocsSelect.length; index++) {
        let docExistInBd = copyDocs.filter((doc) => doc.id === allDocsSelect[index].id)
        if (docExistInBd && docExistInBd.length === 0) {
          copyDocs.push(allDocsSelect[index])
        }
      }
      setDataDocsSelected(copyDocs);
      setDocumentsWasCreatedSelect(allDocsCreateSelected);
    } else {
      let allDocsSelect = allSelected.concat(docsSelected);
      for (let index = 0; index < allDocsSelect.length; index++) {
        let docExistInBd = copyDocs.filter((doc) => doc.id === allDocsSelect[index].id)
        if (docExistInBd && docExistInBd.length === 0) {
          copyDocs.push(allDocsSelect[index])
        }
      }
      setDataDocsSelected(copyDocs);
      setDocumentsWasCreatedSelect(documentsForClientCreated);
    }

    toggleDialogShowAddDocumentRequest();
  };

  //handle documents was selected on dialog
  const handleSelectDialogAnswer = (e) => {

    if (answer !== '') {
      let copyAnswers = [...allAnswers]
      let asnwerObj = {};
      asnwerObj.name = answer;
      asnwerObj.id = ''
      asnwerObj.templateVariableId = 0
      asnwerObj.answerSelected = false
      asnwerObj.answer = answer
      asnwerObj.action = 1

      copyAnswers.push(asnwerObj);
      setDataAnswers(copyAnswers);
      setAllAnswers(copyAnswers)

      if (nameComponentUser === t('questionnairesAdministrationEditDetailView.btn.edit.question')) {
        setAnswersToSend(copyAnswers)
      }

      setAnswer('');
    }
    toggleDialogAnswer();
  };

  //Edit question answer
  const handleEditQuestionAnswer = () => {
    let copyAnswers = [...allAnswers]
    copyAnswers.map((answer) => {
      if (answer.name === editAnswerToSearch) {
        answer.name = editAnswer
        answer.answer = editAnswer
      }
      return answer
    })

    setDataAnswers(copyAnswers)
    setAllAnswers(copyAnswers)
    setEditAnswerToSearch('')
    setEditAnswer('')
    toggleDialogEditAnswer()
  }


  //handle answer from dialog
  const handleAnswer = (e) => {
    setAnswer(e.target.value);
  };

  //handle answer from dialog
  const handleEditAnswer = (e) => {
    setEditAnswer(e.target.value);
  };

  //search by filter name company
  const filterChangeDialog = (e) => {
    setTypePersoneFilter(e.target.value);
  };

  //handle variable was selected on dialog
  const handleSelectDialoVariable = (e) => {
    let copyVars = [...varsFromBd]
    let varSelected = [];
    if (allVariablesSelect.length > 0) {
      for (let i = 0; i < allVariablesSelect.length; i++) {
        let varCopies = [...variablesForQuestionnaire];
        let dataUpdate = varCopies.find((variable) => variable.id === allVariablesSelect[i].id);
        varSelected.push(dataUpdate);
      }
      for (let j = 0; j < varSelected.length; j++) {
        let varExist = copyVars.find((variable) => variable.id === varSelected[j].id)
        if (!varExist) {
          copyVars.push(varSelected[j])
        }
      }
      setDataVaribles(copyVars);
    } else {
      setDataVaribles(copyVars);
    }
    setAllVaribleSelect(varSelected);
    setShowDialogVariable(!showDialogVariable);
  };

  //handle checkbox variable dialog
  const handleChangeCheckboxVariable = (e) => {
    setVariableDialogSelect(e.target.value);
    let copyVars = [...allVariablesSelect]
    if (e.target.checked === true) {
      let variable = variablesToShowInDialog.filter(
        (variable) => variable.name === e.target.name
      );
      variable[0].check = e.target.checked;
      copyVars.push(variable[0]);
      setAllVaribleSelect(copyVars);
    } else {
      let variable = variablesToShowInDialog.filter(
        (variable) => variable.name === e.target.name
      );
      variable[0].check = e.target.checked;
      let newVariable = copyVars.filter(
        (variable) => variable.name !== e.target.name
      );
      setAllVaribleSelect(newVariable);
    }
  };

  useEffect(() => {
    if (variableName > 0) {
      let variableId = variablesToFilter.filter(
        (variable) => variable.id === variableName
      );
      let variables = variablesToFilter.filter(
        (variable) => variable.id !== variableName
      );
      setVariablesToShowInDialog(variables);
    } else {
      setVariablesToShowInDialog(variablesToFilter);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [variableName]);

  //change value of drop boxes to null when select no varaible
  useEffect(() => {
    if (variableName === 0) {
      setFormatForVariable(0);
      setFormatVariable(0);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [variableName]);

  //add value no money and add money to units currency and clean options that are no name
  useEffect(() => {
    let allCurrency = []
    for (let index = 0; index < currencyUnits.length; index++) {
      if (currencyUnits[index].pluralName !== '') {
        allCurrency.push(currencyUnits[index])
      }
    }

    const last = currencyUnits.slice(-1)
    let idAddMoney = last[0].id + 1;
    let noMoney = {
      abbreviation: ' ',
      id: 0,
      key: 'currencyNoMoney',
      name: t('questionnairesAdministrationEditQuestionView-option-no-money'),
      updatedByUser: '',
    };

    let addMoney = {
      abbreviation: ' ',
      id: idAddMoney,
      key: 'currencyAddMoney',
      name: t('questionnairesAdministrationEditQuestionView-option-add-money'),
      updatedByUser: '',
    };

    if (allCurrency[0].id !== noMoney.id) {
      allCurrency.unshift(noMoney);
      allCurrency.push(addMoney);
    }
    setShowCurrency(allCurrency)
    setUnitAddMoneyLength(idAddMoney);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currencyUnits]);

  const toggleWarningRequesting = () => {
    setNameVoidWarning(false);
  };

  const deleteDocSelected = (dataItem) => {
    //delete doc of grid
    let docsCopy = [...dataDocsSelected]
    let copyDocsFromBd = [...docsCLientFromBD]
    let documentsAllSelected = docsCopy.filter((doc) => doc.name !== dataItem.name && doc.id !== '')
    let documents = docsCopy.filter((doc) => doc.name !== dataItem.name)
    let documentsFromBd = copyDocsFromBd.filter((doc) => doc.name !== dataItem.name)
    setDataDocsSelected(documents)
    setAllSelected(documentsAllSelected)
    setDocsCLientFromBD(documentsFromBd)

    // verify if document was created
    let copyDocCreated = [...allDocsCreateSelected]
    let documentsCreated = copyDocCreated.filter((doc) => doc.name !== dataItem.name)
    setAllDcosCreateSelected(documentsCreated)

    //check false document
    let docShowSopy = [...documentsSelect]
    for (let index = 0; index < docShowSopy.length; index++) {
      if (docShowSopy[index].name === dataItem.name) {
        docShowSopy[index].check = false;
        if (nameComponentUser === t('questionnairesAdministrationEditDetailView.btn.edit.question')) {
          docShowSopy[index].action = 3;
        }
      }
    }
    setDocumentSelect(docShowSopy)
  }

  const deleteVarSelected = (dataItem) => {
    //delete var of grid
    let varsCopy = [...dataVariables]
    let vars = varsCopy.filter((variable) => variable.id !== dataItem.id)
    setDataVaribles(vars)
    setAllVaribleSelect(vars)
    //check false
    let varsShowCopy = [...variablesToShowInDialog]
    for (let index = 0; index < varsShowCopy.length; index++) {
      if (varsShowCopy[index].id === dataItem.id) {
        varsShowCopy[index].check = false;
      }
    }

    //if var was save in bd push to arr to show
    let copyVarsBd = [...varsInBd]
    let varAddToArrShow = copyVarsBd.filter((vari) => vari.id === dataItem.id)
    let varExist = varsShowCopy.filter((vari) => vari.id === dataItem.id)
    if (varAddToArrShow && varAddToArrShow.length > 0 && varExist && varExist.length === 0) {
      varsShowCopy.push(varAddToArrShow[0])
    }
    setVariablesToShowInDialog(varsShowCopy)
    setVariablesToFilter(varsShowCopy)

    let copyVarsFromBd = [...varsFromBd]
    let varsNoVarDelete = copyVarsFromBd.filter((vari) => vari.id !== dataItem.id)
    setVarsFomBd(varsNoVarDelete)
  }

  const deleteOptionAnswer = (dataItem) => {
    let copyAnswers = [...allAnswers]
    copyAnswers.map((answer) => {
      if (answer.name === dataItem.name) {
        answer.action = 3
      }

      return answer
    })

    let answers = copyAnswers.filter((answer) => answer.name !== dataItem.name)

    setDataAnswers(answers)
    setAllAnswers(answers)
    setAnswersToSend(copyAnswers)
  }

  const EditOptionAnswer = (dataItem) => {
    toggleDialogEditAnswer()
    setEditAnswer(dataItem.name)
    setEditAnswerToSearch(dataItem.name)
  }

  const styleGrid = {
    fontFamily: 'Quicksand, sans-serif',
    maxHeight: 'calc(50px * 5.5)',
    overflowY: 'auto',
    overflowX: 'hidden',
    overscrollBehavior: 'contain',
    borderRight: '1px solid rgb(200, 200, 200) !important',
    maxHeight: '312px'
  }

  return showGettingData ? (
    <div className='questionnairesAdministrationEditQuestionView-loader'>
      <SimpleLoading />
    </div>
  ) : (
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <DialogSystemGLPure
        toggleLoadingRequesting={toggleLoadingRequesting}
        showLoadingRequesting={showLoadingRequesting}
        toggleCompletedRequesting={toggleCompletedRequesting}
        showCompletedRequesting={showCompletedRequesting}
        toggleWarningRequesting={toggleWarningRequesting}
        showWarningRequesting={nameVoidWarning}
        messageWarning={messageError}
        toggleErrorRequesting={toggleErrorRequesting}
        showErrorRequesting={showErrorRequesting}
        messageError={messageError}
      />

      <Container maxWidth={'md'} disableGutters>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Grid
              container
              spacing={2}
              zeroMinWidth={true}
            >
              <Grid item xs={12} md={6}>
                <DropDownBtnHLPure
                  labelDropDown={t(
                    'questionnairesAdministrationEditQuestionView.label.select.variable.title'
                  )}
                  optionsDropDown={variablesunshift}
                  onDropDownChange={(event) => handleVariable(event)}
                  valueItem='id'
                  nameOption='name'
                  tooltipShow={true}
                  informationIcon={true}
                  titleTooltip={t(
                    'questionnairesAdministrationEditQuestionView.tooltip.select.variable.title'
                  )}
                  descriptionTooltip={t(
                    'questionnairesAdministrationEditQuestionView.tooltip.select.variable.description'
                  )}
                  positionTooltip={isMobile ? "top" : "right"}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                {variableName > 0 ? (
                  <DropDownBtnHLPure
                    labelDropDown={t(
                      'questionnairesAdministrationEditQuestionView-drop-down-format-for-variable'
                    )}
                    optionsDropDown={showFormatForVariableOptions}
                    onDropDownChange={(event) => handleFormatToVariable(event)}
                    valueItem='id'
                    nameOption='name'
                  />
                ) : (
                  <DropDownBtnHLPure
                    labelDropDown={t(
                      'questionnairesAdministrationEditQuestionView.label.tipe.question.title'
                    )}
                    optionsDropDown={optionsToShow}
                    onDropDownChange={(event) => handleTypeQuestion(event)}
                    valueItem='value'
                    nameOption='name'
                  />
                )}
              </Grid>

              {/* TEXTO */}
              {
                ((formatForVarible === 0 && variableName > 0) || (typeQuestion === 'text' && variableName === 0)) ?
                  (
                    <Grid item xs={12} md={6}>
                      <DropDownBtnHLPure
                        labelDropDown={t('digitalContractDashboard.manageQuestion.textDetails')}
                        optionsDropDown={formatText}
                        onDropDownChange={(e) => handleFormatText(e)}
                        valueItem='id'
                        nameOption='format'
                        optionsValue={textValue}
                      />
                    </Grid>
                  ) : null
              }

              {/* MONTO */}
              {formatForVarible === 1 && variableName > 0 && (
                <>
                  <Grid item xs={12} md={6}>
                    <DropDownBtnHLPure
                      labelDropDown={t(
                        'questionnairesAdministrationEditQuestionView-drop-down-format-variable'
                      )}
                      optionsDropDown={formatNumbers}
                      onDropDownChange={(event) => handleFormatVariable(event)}
                      valueItem='id'
                      nameOption='format'
                      optionsValue={numbersValue}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <DropDownBtnHLPure
                          labelDropDown={t(
                            'questionnairesAdministrationEditQuestionView-drop-down-unity'
                          )}
                          optionsDropDown={showCurrency}
                          onDropDownChange={(event) => handleMoneyVariable(event)}
                          valueItem='id'
                          nameOption='pluralName'
                          optionsValue={monedaTypeValue}
                        />
                      </Grid>

                      {Number(money) === 0 && (
                        <Grid item xs={12}>
                          <Grid container spacing={2} alignItems='flex-end'>
                            <Grid item xs={8}>
                              <InputHLPure
                                labelInput={t(
                                  'questionnairesAdministrationEditQuestionView-drop-down-unity'
                                )}
                                typeInput={'text'}
                                valueInput={unity}
                                handleChangeInput={(e) => handleUnidadInput(e)}
                                inputActive={true}
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <CheckBoxHLPure
                                onChangeHandler={handleCheckBoxMoneyNoMoney}
                                labelCheckBox={t('questionnairesAdministrationEditQuestionView-check-box-money')}
                                idCheckBox={t('questionnairesAdministrationEditQuestionView-check-box-money')}
                                valueCheckBox={true}
                                checkedState={valueCheckBoxMoneyNoMoney}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      )}

                      {Number(money) > 0 && Number(money) < unitAddMoneyLength && (
                        <Grid item xs={12}>
                          <CheckBoxHLPure
                            onChangeHandler={handleCheckBoxMoney}
                            labelCheckBox={t('questionnairesAdministrationEditQuestionView-check-box-money')}
                            idCheckBox={t('questionnairesAdministrationEditQuestionView-check-box-money')}
                            valueCheckBox={true}
                            checkedState={valueCheckBoxMoney}

                          />
                        </Grid>
                      )}

                      {Number(money) === unitAddMoneyLength && (
                        <Grid item xs={12}>
                          <Grid container spacing={2}>
                            <Grid
                              item
                              md={4}
                              xs={12}
                            >
                              <InputHLPure
                                labelInput={t(
                                  'questionnairesAdministrationEditQuestionView.label.add.money.money'
                                )}
                                typeInput={'text'}
                                valueInput={moneyAdd}
                                handleChangeInput={(e) => handleUnidadInputMoneyAdd(e)}
                                inputActive={true}
                              />
                            </Grid>
                            <Grid
                              item
                              md={4}
                              xs={12}
                            >
                              <InputHLPure
                                labelInput={t(
                                  'questionnairesAdministrationEditQuestionView.label.add.money.simbol'
                                )}
                                typeInput={'text'}
                                valueInput={simbolAdd}
                                handleChangeInput={(e) => handleUnidadInputSimbolAdd(e)}
                                inputActive={true}
                              />
                            </Grid>
                            <Grid
                              item
                              md={4}
                              xs={12}
                            >
                              <InputHLPure
                                labelInput={t(
                                  'questionnairesAdministrationEditQuestionView.label.add.money.money.name'
                                )}
                                typeInput={'text'}
                                valueInput={nameMoneyAdd}
                                handleChangeInput={(e) =>
                                  handleUnidadInputNameMoneyAdd(e)
                                }
                                inputActive={true}
                              />
                            </Grid>
                            <Grid
                              item
                              xs={12}
                            >
                              <CheckBoxHLPure
                                onChangeHandler={handleCheckBoxAddMoney}
                                labelCheckBox={t('questionnairesAdministrationEditQuestionView-check-box-money')}
                                idCheckBox={t('questionnairesAdministrationEditQuestionView-check-box-money')}
                                valueCheckBox={true}
                                checkedState={valueCheckBoxMoneyAddMoney}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </>
              )}

              {/* FECHA */}
              {formatForVarible === 2 && variableName > 0 && (
                <Grid item xs={12} md={6}>
                  <DropDownBtnHLPure
                    labelDropDown={t(
                      'questionnairesAdministrationEditQuestionView-drop-down-format-date-title'
                    )}
                    optionsDropDown={datesFormat}
                    onDropDownChange={(e) => handleFormatDates(e)}
                    valueItem='id'
                    nameOption='format'
                    optionsValue={dateValue}
                  />
                </Grid>
              )}
              {/*OPCIONES LÓGICAS*/}
              {(formatForVarible === 3 && variableName > 0) && (
                <div className='questionnairesAdministrationEditQuestionView-logic-container'>
                  <div className='questionnairesAdministrationEditQuestionView-logic'>
                    <InputLogicHLPure
                      labelInput={t('questionnairesAdministrationEditQuestionView.logic.name.truly')}
                      typeInput={'text'}
                      handleChangeInput={(e) => onChangeTextlogic(e, 0)}
                      valueInput={logicOptions[0].name}
                      inputActive={true}
                    />
                    <InputLogicHLPure
                      labelInput={t('questionnairesAdministrationEditQuestionView.logic.name.falsy')}
                      typeInput={'text'}
                      handleChangeInput={(e) => onChangeTextlogic(e, 1)}
                      valueInput={logicOptions[1].name}
                      inputActive={true}
                    />
                  </div>
                </div>
              )}
              {/*SELECTOR DE OPCIONES*/}
              {(formatForVarible === 4 && variableName > 0) && (
                <div className='questionnairesAdministrationEditQuestionView-selector-container'>
                  <div className='questionnairesAdministrationEditQuestionView-selector-items'>
                    <div className='questionnairesAdministrationEditQuestionView-selector-checkBox'>
                      <CheckBoxTemplatePure
                        label={selectorOptions.type[0].name}
                        id={'uniqueSelection'}
                        name={'uniqueSelection'}
                        value={selectorOptions.type[0].value}
                        checked={selectorOptions.type[0].value}
                        onChange={(e) => handleChangeCheckboxSelector(e, selectorOptions.type[0].name)}
                      />
                      <CheckBoxTemplatePure
                        label={selectorOptions.type[1].name}
                        id={'uniqueSelection'}
                        name={'uniqueSelection'}
                        value={selectorOptions.type[1].value}
                        checked={selectorOptions.type[1].value}
                        onChange={(e) => handleChangeCheckboxSelector(e, selectorOptions.type[1].name)}
                      />
                    </div>
                    <div>
                      {selectorOptions && selectorOptions.options && selectorOptions.options.length > 0 && selectorOptions.options.map((option, index) =>
                        <div className='questionnairesAdministrationEditQuestionView-selector-options'>
                          <InputHLPure
                            key={index}
                            inputActive
                            labelInput={t('questionnairesAdministrationEditQuestionView.selector.name')}
                            typeInput='text'
                            handleChangeInput={(e) => onChangeTextSelection(e, index)}
                            valueInput={option.name}
                          />
                        </div>
                      )}
                      <div className='questionnairesAdministrationEditQuestionView-selector-btn'>
                        <ButtonAddHLPure
                          onClickBtn={addOption}
                          iconAdd
                          nameBtn={t('questionnairesAdministrationEditQuestionView.btn.add.option')}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <hr />
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextAreaHLPure
                  labelTextArea={t(
                    'questionnairesAdministrationEditQuestionView.label.input.question.title'
                  )}
                  valueTextData={questionName}
                  tooltipShow={true}
                  informationIcon={true}
                  titleTooltip={t(
                    'questionnairesAdministrationEditQuestionView.label.input.question.tooltip.title'
                  )}
                  descriptionTooltip={t(
                    'questionnairesAdministrationEditQuestionView.label.input.question.tooltip.description'
                  )}
                  positionTooltip={isMobile ? "top" : "right"}
                  handleChangeTextArea={(e) => handleQuestionName(e)}
                />
              </Grid>
              <Grid item xs={12}>
                <TextAreaHLPure
                  labelTextArea={t(
                    'questionnairesAdministrationEditQuestionView.label.input.text.help.title'
                  )}
                  valueTextData={helpText}
                  tooltipShow={true}
                  informationIcon={true}
                  titleTooltip={t(
                    'questionnairesAdministrationEditQuestionView.label.input.text.help.tooltip.title'
                  )}
                  descriptionTooltip={t(
                    'questionnairesAdministrationEditQuestionView.label.input.text.help.tooltip.description'
                  )}
                  positionTooltip={isMobile ? "top" : "right"}
                  handleChangeTextArea={(e) => handleHelpText(e)}
                />
              </Grid>
            </Grid>
          </Grid>

          {(variableName !== 0 || typeQuestion != 'text') &&
            <>
              <Grid item xs={12}>
                <hr />
              </Grid>


              <Grid item xs={12}>
                <Grid container spacing={2}>
                  {variableName === 0 && typeQuestion !== 'text' && (
                    <>
                      <Grid item xs={12}>
                        <LabelPure title={t('digitalContractDashboard.manageQuestion.answerOptions')} />
                      </Grid>
                      <Grid item xs={12}>
                        <ButtonAddHLPure
                          iconAdd={true}
                          nameBtn={t(
                            'questionnairesAdministrationEditQuestionView.btn.add.request.name.title'
                          )}
                          onClickBtn={toggleDialogAnswer}
                        />
                      </Grid>
                      <Grid item xs={12}
                      >
                        <GridHLPure
                          styleGrid={styleGrid}
                          dataGrid={dataAnswers}
                          skip={0}
                          take={2}
                          iconAvatar={false}
                          titleRow1={t(
                            'questionnairesAdministrationEditQuestionView.grid.answers.title.column.1'
                          )}
                          fieldRow1={'name'}
                          onSelectedItem={setDocumentItem}
                          column2Status={false}
                          columnThree={false}
                          columnFour={true}
                          iconActiveThree={false}
                          iconOneActive
                          iconTwoActive
                          activeDialog1={true}
                          iconStatus={false}
                          labelOneActions={'Eliminar'}
                          labelTwoActions={'Editar'}
                          minHeight={'0'}
                          btnOpenDialog1={(dataItem) => deleteOptionAnswer(dataItem)}
                          activeDialog2
                          btnOpenDialog2={(dataItem) => EditOptionAnswer(dataItem)}
                          styleCol4={'questionnairesAdministrationEditQuestionView-styleCol4'}
                          widthHeaderCol4={'questionnairesAdministrationEditQuestionView-styleHeader4'}
                        />
                      </Grid>
                    </>
                  )}

                  {
                    variableName !== 0 && <>
                      <Grid item xs={12}>
                        <LabelPure title={t('digitalContractDashboard.manageQuestion.relatedDocuments')} />
                      </Grid>
                      <Grid item xs={12}>
                        <Grid container className='questionnairesAdministrationEditQuestionView-btn-group gap' justify='flex-start' wrap='wrap'>
                          <ButtonAddHLPure
                            iconAdd={true}
                            nameBtn={t(
                              'questionnairesAdministrationEditQuestionView-btn-add-validate'
                            )}
                            onClickBtn={toggleDialog}
                          />

                          <ButtonAddHLPure
                            iconAdd={true}
                            nameBtn={t(
                              'questionnairesAdministrationEditQuestionView-btn-add-request'
                            )}
                            onClickBtn={toggleDialogShowAddDocumentRequest}
                          />
                        </Grid>
                      </Grid>

                      <Grid item xs={12}>
                        <GridHLPure
                          styleGrid={styleGrid}

                          dataGrid={dataDocsSelected}
                          skip={0}
                          take={2}
                          titleRow1={t(
                            'questionnairesAdministrationEditQuestionView.grid.documents.title.column.1'
                          )}
                          titleRow3={t(
                            'questionnairesAdministrationEditQuestionView.grid.documents.title.column.2'
                          )}
                          titleRow4={isMobile ? t(
                            'questionnairesAdministrationView.accions.title.grid'
                          ) : ''}
                          fieldRow1={'name'}
                          onSelectedItem={setDocumentItem}
                          column2Status={false}
                          columnThree={isMobile}
                          columnFour={true}
                          iconActiveThree={false}
                          iconOneActive
                          iconAvatar={false}
                          iconColumnThree={false}
                          activeDialog1={true}
                          iconStatus={false}
                          labelOneActions={'Eliminar'}
                          fieldRow3={'typeDocument'}
                          textColumnThree={'typeDocument'}
                          minHeight={'0'}
                          btnOpenDialog1={(dataItem) => deleteDocSelected(dataItem)}
                          styleCol3={'questionnairesAdministrationEditQuestionView-styleCol3'}
                          widthHeaderCol3={'questionnairesAdministrationEditQuestionView-styleCol3'}
                          styleCol4={'questionnairesAdministrationEditQuestionView-styleCol4 short'}
                          widthHeaderCol4={'questionnairesAdministrationEditQuestionView-styleHeader4 short'}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <LabelPure title={t('digitalContractDashboard.manageQuestion.additionalVariables')} />
                      </Grid>
                      <Grid item xs={12}>
                        <ButtonAddHLPure
                          iconAdd={true}
                          nameBtn={t(
                            'questionnairesAdministrationEditQuestionView-btn-add-variable-to-question'
                          )}
                          onClickBtn={toggleDialogVariable}
                        />
                      </Grid>
                      <Grid item xs={12} >
                        <GridHLPure
                          styleGrid={styleGrid}
                          dataGrid={dataVariables}
                          skip={0}
                          take={2}
                          titleRow1={t(
                            'questionnairesAdministrationEditQuestionView-grid-add-variable-title-row-1'
                          )}
                          titleRow4={isMobile ? t(
                            'questionnairesAdministrationView.accions.title.grid'
                          ) : ''}
                          fieldRow1={'name'}
                          onSelectedItem={setDocumentItem}
                          column2Status={false}
                          columnThree={false}
                          columnFour={true}
                          iconActiveThree={false}
                          iconOneActive
                          iconAvatar={false}
                          activeDialog1={true}
                          iconStatus={false}
                          labelOneActions={'Eliminar'}
                          minHeight={'0'}
                          btnOpenDialog1={(dataItem) => deleteVarSelected(dataItem)}
                          styleCol4={'questionnairesAdministrationEditQuestionView-styleCol4 short'}
                          widthHeaderCol4={'questionnairesAdministrationEditQuestionView-styleHeader4 short'}
                        />
                      </Grid>
                    </>
                  }
                </Grid>
              </Grid>
            </>
          }

          <Grid item xs={12}>
            <Grid container className='questionnairesAdministrationEditQuestionView-btn-group' justify='flex-end' wrap='wrap'>
              <ButtonHLPure
                nameBtn={t('button.cancel')}
                onClickBtn={() => {
                  setNameComponentUser(t('questionnairesAdministrationView.btn.adm.questions.grid'));
                  setTimeout(() => {
                    setShowDetails(true);
                  }, 500);
                }}
              />

              <ButtonHLPure
                nameBtn={t('button.save')}
                primary
                onClickBtn={updateQuestion}
              />
            </Grid>
          </Grid>
        </Grid>
      </Container>

      {showDialog && (
        <DialogFormHLPure
          cancel={cancelDialog}
          titleDialog={t('dialogSignRequestPure.titleDialogSignRequest')}
          descriptionActive={true}
          descriptionDialog={t(
            'questionnairesAdministrationEditQuestionView.dialog.documents.title'
          )}
          textBtnCancel={t('button.cancel')}
          saveBtn={t(
            'questionnairesAdministrationEditQuestionView.dialog.documents.btn.include'
          )}
          handleSubmit={handleSelectDialogDocuments}
        >
          <div className='questionnairesAdministrationView-dialog-body'>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <SearchBarHLPure
                  placeholder={t(
                    'questionnairesAdministrationView.seacrh.placeholder'
                  )}
                  onSearchChange={(e) => searchChangeDialog(e)}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FilterHLPure
                  options={typePersonsFilter}
                  nameOption='value'
                  valueItem='id'
                  onFilterChange={(event) => filterChangeDialog(event)}
                />
              </Grid>
            </Grid>
            <div className='questionnairesAdministrationEditQuestionView-checkboxes'>
              {documentsSelect.map((item) =>
                <Grid item xs={12}>
                  <CheckBoxHLPure
                    onChangeHandler={handleChangeCheckbox}
                    labelCheckBox={item.name}
                    idCheckBox={item.name}
                    valueCheckBox={item.id}
                    checkedState={item.check !== true ? false : item.check}
                  />
                </Grid>
              )}
            </div>
          </div>
        </DialogFormHLPure>
      )}

      {showDialogAddDocumentRequest && (
        <DialogFormHLPure
          cancel={cancelDialogAddDocumentRequest}
          titleDialog={t('dialogSignRequestPure.titleDialogSignRequest')}
          descriptionActive={true}
          descriptionDialog={t(
            'questionnairesAdministrationEditQuestionView-dialog-validate-documents-title'
          )}
          textBtnCancel={t('button.cancel')}
          saveBtn={t(
            'questionnairesAdministrationEditQuestionView-dialog-validate-documents-btn-include'
          )}
          handleSubmit={handleDocCreated}
        >
          <div className='questionnairesAdministrationView-dialog-body'>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <SearchBarHLPure
                  placeholder={t(
                    'questionnairesAdministrationView.seacrh.placeholder'
                  )}
                  onSearchChange={(e) => searchChangeDialogDocCreated(e)}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <InputIconPlusHLPure
                  typeInput={'text'}
                  placeholder={''}
                  valueInput={requestDocument}
                  handleChangeInput={(e) => handleInputAddDocument(e)}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <ButtonAddHLPure
                  nameBtn={t('digitalContractDashboard.manageQuestion.addDocument')}
                  onClickBtn={saveDocumentRequest}
                  iconAdd={true}
                />
              </Grid>
            </Grid>
          </div>
          <div className='questionnairesAdministrationEditQuestionView-checkboxes'>
            {documentsWasCreatedSelect.map((item) =>
              <Grid item xs={12}>
                <CheckBoxHLPure
                  onChangeHandler={handleCheckBoxDocumentsWasCreated}
                  labelCheckBox={item.name}
                  idCheckBox={item.name}
                  valueCheckBox={item.id}
                  checkedState={item.check !== true ? false : item.check}
                />
              </Grid>
            )}
            {
              documentExist &&
              <Grid item xs={12}>
                <p className='hint-message-error'>{t('questionnairesAdministrationView.label.document.exist')}</p>
              </Grid>
            }
          </div>
        </DialogFormHLPure>
      )}

      {showDialogAnswer && (
        <DialogFormHLPure
          cancel={cancelDialogAnswer}
          titleDialog={t('dialogSignRequestPure.titleDialogSignRequest')}
          descriptionActive={true}
          descriptionDialog={t(
            'questionnairesAdministrationEditQuestionView.dialog.answer.title'
          )}
          textBtnCancel={t('button.cancel')}
          saveBtn={t('button.save')}
          handleSubmit={handleSelectDialogAnswer}
        >
          <div className='questionnairesAdministrationView-dialog-body'>
            <Grid container spacing={2}>
              {
                (questionName && Object.keys(questionName).length !== 0) &&
                <Grid item xs={12}>
                  <LabelPure title={questionName} />
                </Grid>
              }
              <Grid item xs={12}>
                <TextAreaHLPure
                  labelTextArea={t(
                    'questionnairesAdministrationEditQuestionView.dialog.answers.title'
                  )}
                  valueTextData={answer}
                  handleChangeTextArea={(e) => handleAnswer(e)}
                />
              </Grid>
            </Grid>
          </div>
        </DialogFormHLPure>
      )}

      {showDialogVariable && (
        <DialogFormHLPure
          cancel={cancelDialogVariabel}
          titleDialog={t('dialogSignRequestPure.titleDialogSignRequest')}
          descriptionActive={true}
          descriptionDialog={t(
            'questionnairesAdministrationEditQuestionView.dialog.variable.title'
          )}
          textBtnCancel={t('button.cancel')}
          saveBtn={t('button.save')}
          handleSubmit={handleSelectDialoVariable}
        >
          <div className='questionnairesAdministrationView-dialog-body'>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <LabelPure
                  title={t(
                    'questionnairesAdministrationEditQuestionView.dialog.variable.desctiption'
                  )}
                />
              </Grid>
              {variablesToShowInDialog.map((item) =>
                <Grid item xs={12}>
                  <CheckBoxHLPure
                    onChangeHandler={handleChangeCheckboxVariable}
                    labelCheckBox={item.name}
                    idCheckBox={item.name}
                    valueCheckBox={item.id}
                    checkedState={item.check !== true ? false : item.check}
                  />
                </Grid>
              )}
            </Grid>
          </div>
        </DialogFormHLPure>
      )}

      {showDialogEditAnswer && (
        <DialogFormHLPure
          cancel={cancelDialogEditAnswer}
          titleDialog={t('dialogSignRequestPure.titleDialogSignRequest')}
          descriptionActive={true}
          descriptionDialog={'Editar la respuesta'}
          textBtnCancel={t('button.cancel')}
          saveBtn={t('button.save')}
          handleSubmit={handleEditQuestionAnswer}
        >
          <div className='questionnairesAdministrationView-dialog-body'>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextAreaHLPure
                  labelTextArea={t(
                    'questionnairesAdministrationEditQuestionView.dialog.answers.title'
                  )}
                  valueTextData={editAnswer}
                  handleChangeTextArea={(e) => handleEditAnswer(e)}
                />
              </Grid>
            </Grid>
          </div>
        </DialogFormHLPure>
      )}

    </Grid>
  );
};
export default QuestionnairesAdministrationEditQuestionView;
